module.exports = __webpack_public_path__ + "img/Slack_Mark_Monochrome_White.678ca33e.svg";